import type { z } from "zod";
import { env } from "@/lib/env";

// biome-ignore lint/complexity/noStaticOnlyClass: <this is a utility class>
export class LocalStorage {
  static readonly TOKENS_KEY = "auth_tokens";
  static readonly LOGIN_ATTEMPTS_KEY = "login_attempts";

  static set<T>(key: string, value: T, expireInMs?: number) {
    const record: { value: T; expiry: number | null } = {
      value,
      expiry: expireInMs ? Date.now() + expireInMs : null,
    };

    localStorage.setItem(`${env.VITE_LS_KEY_PREFIX}::${key}`, JSON.stringify(record));
  }

  static get<T>(key: string, schema: z.ZodType<T>): T | null {
    const item = localStorage.getItem(`${env.VITE_LS_KEY_PREFIX}::${key}`);
    if (!item) return null;

    try {
      const record: { value: unknown; expiry: number | null } = JSON.parse(item);
      if (record.expiry && Date.now() > record.expiry) {
        localStorage.removeItem(key);
        return null;
      }
      const parsed = schema.parse(record.value);
      return parsed;
    } catch {
      localStorage.removeItem(key);
      return null;
    }
  }

  static remove(key: string) {
    localStorage.removeItem(`${env.VITE_LS_KEY_PREFIX}::${key}`);
  }
}
